import React, { useEffect, useState } from 'react'
import "./SendTestMessageModal.scss";
import ModalLD3 from '../../../../common/Modal/ModalLD3';
import { Button, TextField } from '@livingdesign/react';
import EmailInputField from '../../../../common/EmailInputField';
import { COPY, MAX_TEST_RECIPIENTS } from '../../../../../../consts/Copy';
import { NOTIFICATION_CHANNELS } from '../../../../../../consts/Campaign';
import { useMessageDetailsForm } from '../../../../../../contexts/MessageDetailsForm';
import { getTemplateMustacheVariables } from '../../../../../template/EmailEditor/grapesjs/util';
import { getTeamsTemplateVariables } from '../../../../../../utils/template';
import { useCampaignContext } from '../../../../../../contexts/Campaign';

export const QA_ID_PREFIX = "SendTestMessageModal";

function SendTestMessageModal({
    isOpen,
    onClose,
    id,
}) {

    const {
        sendCampaignTest,
    } = useCampaignContext();

    const {
        formValues,
        channel,
    } = useMessageDetailsForm();

    const [recipients, setRecipients] = useState([]);
    const [maxRecipientsError, toggleMaxRecipientsError] = useState(false);
    const [loading, toggleLoading] = useState(false);
    const [variableNames, setVariableNames] = useState([]);
    const [variables, setVariables] = useState({});
    const [emailError, toggleEmailError] = useState(false);

    useEffect(() => {
        if (!isOpen) {
          setRecipients([]);
          toggleMaxRecipientsError(false);
        }
    }, [isOpen]);

    useEffect(() => {
        let content = formValues?.templateContent;
        
        let variables = {};
        switch (channel) {
        case NOTIFICATION_CHANNELS.mail.value:
            variables = getTemplateMustacheVariables(content);
            break;
        case NOTIFICATION_CHANNELS.teams.value:
            variables = getTeamsTemplateVariables(content);
            break;
        default:
            break;
        }
        
        setVariableNames(variables || {});
    }, [formValues?.templateContent]);

    return (
        <>
            <ModalLD3
                isOpen={isOpen}
                onClose={onClose}
                title={"Send test message"}
                size={"medium"}
                id={`${QA_ID_PREFIX}-${id}`}
                UNSAFE_style={{overflow: 'none'}}
                actions={
                <div
                    style={{
                        gap: "16px",
                        display: 'flex'
                    }}
                    data-testid={`${QA_ID_PREFIX}-actions-container`}
                >
                    <Button
                        variant='secondary'
                        onClick={onClose}
                        id={`${QA_ID_PREFIX}-CancelButton`}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant='primary'
                        onClick={async () => {
                            toggleLoading(true);
                            await sendCampaignTest(recipients, variables);
                            toggleLoading(false);
                            onClose();
                        }}
                        disabled={loading || !recipients.length}
                        id={`${QA_ID_PREFIX}-SendTestMessageButton`}
                    >
                        Send test message
                    </Button>
                </div>}
            >
                <form data-testid={`${QA_ID_PREFIX}-form`}>
                    <div data-testid={`${QA_ID_PREFIX}-description`}>Test notifications will only be sent to the people you specify below and won't affect your message metrics.</div>
                    <div style={{marginTop: "8px"}} className='typo-1' data-testid={`${QA_ID_PREFIX}-required-field-text`}>*Required field</div>
                    <div
                        style={{marginTop: "8px"}}
                        data-testid={`${QA_ID_PREFIX}-recipients-container`}
                    >
                        <EmailInputField
                            multiple
                            handleChange={(value) => {
                                if (value?.length <= MAX_TEST_RECIPIENTS) {
                                    setRecipients(value);
                                    toggleMaxRecipientsError(false);
                                } else {
                                    toggleMaxRecipientsError(true);
                                }
                            }}
                            value={recipients}
                            // setError={toggleEmailError}
                            field={{
                                label: "Recipients",
                                name: "Recipients",
                                placeholder: COPY.CAMPAIGN_EDIT.SEND.TEST.PLACEHOLDER_TEXT,
                                required: true,
                            }}
                            componentKey="send-test-recipients"
                            chipProps={{ color: "primary", variant: "outlined" }}
                            id={`${QA_ID_PREFIX}-TestRecipientsField`}
                            isLookUp={true}
                        />
                    </div>
                    <div className='typo-1' style={{marginTop: "4px"}} data-testid={`${QA_ID_PREFIX}-recipients-help-text`}>Enter the name or email of your recipients</div>
                    <div data-testid={`${QA_ID_PREFIX}-variables-container`}>
                        {!!Object.keys(variableNames)?.length && (
                            <>
                                <div style={{marginTop: "16px"}} data-testid={`${QA_ID_PREFIX}-variables-title`}>
                                    <strong>{COPY.CAMPAIGN_EDIT.SEND.TEST.TITLE_VARIABLES}</strong>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "4px",
                                        flexWrap: "wrap",
                                    }}
                                    data-testid={`${QA_ID_PREFIX}-variables-fields-container`}
                                >
                                    {Object.entries(variableNames).map(([varName, value], index) => (
                                        <TextField
                                            key={varName}
                                            label={value.srcname}
                                            UNSAFE_style={{marginTop: "8px", maxWidth: "180px"}}
                                            value={variables[varName]}
                                            data-testid={`${QA_ID_PREFIX}-variable-field-${index}`}
                                            onChange={(e) => {
                                                let updatedVars = { ...variables };
                                                if (e.target.value) {
                                                    updatedVars[varName] = e.target.value;
                                                } else {
                                                    delete updatedVars[varName];
                                                }
                                                setVariables(updatedVars);
                                            }}
                                        />
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </form>
            </ModalLD3>
        </>
    )
}

export default SendTestMessageModal;